<script>
  import Button from "./Button.svelte";
  import { _ as t } from "svelte-i18n";

  export let title;
  export let text;
  export let onClose;

  const handleClose = () => {
    onClose();
  };
</script>

<style>
  .wrapper {
    text-align: center;
  }

  p {
    margin-bottom: 48px;
  }
</style>

<div class="wrapper">
  <h1>{title}</h1>
  <p>{text}</p>
  <Button on:click={handleClose}>{$t('common.close')}</Button>
</div>
